export default __webpack_public_path__ + "static/logo-transparent-1-b006809dec31c9f77f2856a9956b3f22.gif";